if (typeof JW === 'undefined') JW = {};
JW.DateBook = (function ($)
{
    var _pri = {};
    var publ = {};
    var State;

    _pri.cname = 'DATEBOOK';
    _pri.opts = {

        dbg_lvl:        1,
        day_lst_url:    '/_dbd_if', // datebook if
        rx_fe_ds:       /^[0-3][0-9]\.[01][0-9]\.20[0-9]{2}$/,
        dp_opts: {
            autoclose:              false,
            calendarWeeks:          true,
            daysOfWeekHighlighted:  [0, 6],
            daysOfWeekDisabled:     [0, 6],
            format:                 'dd.mm.yyyy',
            language:               'de',
            todayBtn:               false,
            todayHighlight:         true,
            weekStart:              1,
            maxViewMode:            2,
            container:              '#wrp_cal',
            clsnms:                 'nai datebook w-100',
            templates: {
                leftArrow:  '<i class="fa fa-chevron-left"></i>',
                rightArrow: '<i class="fa fa-chevron-right"></i>'
            }
        }
    };

    _pri.uid        = '';
    _pri.$win       = $(window);
    _pri.db_id      = '';

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init0 = function()
    {
        console.log('[' + _pri.cname + '] *** init0()');

        if (document.readyState === 'complete')
        {
            _pri.init1();
        }
        else
        {
            console.log('[' + _pri.cname + ']     listen to window load event ...');
            _pri.$win.on('load', _pri.init1);
        }
    };

    _pri.init1 = function()
    {
        _pri.extend();

        _pri.dbgG('*** init1()');

        if (_pri.inited)
        {
            _pri.dbgR('    !!! already inited!');
            return;
        }

        _pri.inited   = true;
        State         = JW.State;
        _pri.page     = JW.Page;
        _pri.modal    = JW.Modal;
        _pri.uid      = JW.Page.getUId();
        _pri.$doc     = $(document);

        $(document).on('click keyenter', '.tdact.tdbook',  _pri.onSlotClick);
        $(document).on('click keyenter', '#btn_dbfrm_sub', _pri.onDbFrmSubClick);
        $(document).on('click keyenter', '#btn_dbfrm_bck', _pri.onBckClick);
        $(document).on('click keyenter', '.mdl-close-db',  _pri.onCloseDb);

        if (typeof _pri.page.getState === 'function' && _pri.page.getState() == State.STATE_LOADED)
        {
            _pri.initDateBook();
        }
        else
        {
            _pri.dbg('    listen for page:load_done ...');
            _pri.page.on('page:load_done', _pri.initDateBook, 'page:load_done' + _pri.uid);
            _pri.page.on('datebook:lsdbd_on_load', _pri.initDateBook, 'datebook:lsdbd_on_load' + _pri.uid);
        }
    }

    _pri.initDateBook = function(e, o)
    {
        _pri.dbgG('*** initDateBook()');

        _pri.page.off('page:load_done', _pri.initDateBook, 'page:load_done' + _pri.uid);

        if (_pri.db_id != '')
        {
            _pri.dbgR('    !!! still inited! ...');
            return;
        }

        _pri.day_cur    = '';
        _pri.tss        = null;
        _pri.$wrp_db    = $('#wrp_db');
        _pri.$wrp_slots = $('#wrp_slots');
        _pri.$wrp_lst   = $('#wrp_lst');
        _pri.$wrp_frm   = $('#wrp_db_frm');

        if (_pri.$wrp_db.length == 0 || _pri.$wrp_slots.length == 0)
        {
            _pri.dbg('    no wrp - return');
            return;
        }

        _pri.$cal = _pri.$wrp_db.find('.datepicker.nai');

        if (_pri.$cal.length == 0)
        {
            _pri.dbgR('!!! missing datepicker - return!');
            return;
        }

        _pri.conf = _pri.$wrp_db.data('datebook');
        if (!_pri.isObj(_pri.conf))
        {
            _pri.dbgR('!!! missing data-datebook - return!');

            return;
        }

        _pri.updOpts();

        let dp = _pri.$cal.datepicker(_pri.opts.dp_opts);

        dp.on('changeDate', _pri.onChangeDate);

        _pri.$cal.datepicker('setDate', _pri.opts.dp_opts.startDate);

        _pri.db_id = _pri.page.getUId();
    };

    _pri.setDay = function(day)
    {
        _pri.dbg('*** setDay() day:', day);

        if (_pri.day_cur != day && _pri.validDay(day))
        {
            _pri.day_cur = day;

            let cll = {
                _url:   _pri.opts.day_lst_url,
                _msk:   false,
                _dtp:   'JSON',
                _frmdt: {
                    act:     'get_slots',
                    fair_id: _pri.conf.fair_id,
                    ls_id:   _pri.conf.ls_id,
                    fe_ds:   _pri.day_cur
                }
            };

            _pri.modal.cll(cll, _pri.onSetDay);
        }
    };

    _pri.onSetDay = function(xhr)
    {
        _pri.dbgG('*** onSetDay() xhr:', xhr);

        var ret = JSON.parse(xhr.responseText);
        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

        _pri.$wrp_lst = $('#wrp_lst');

        _pri.$wrp_lst.find('[data-toggle="tooltip"]').tooltip({
            html: true,
            // container: 'body',
            // trigger: 'click',
            trigger : 'hover',
            template: '<div class="tooltip nosel zix-mx" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-3 text-left"></div></div>',
            boundary: 'viewport'
        });


        let $first_act = $('.first_act');
        if ($first_act.length > 0)
        {
            _pri.$wrp_lst.animate({scrollTop: _pri.$wrp_lst.scrollTop() + ($('.first_act').offset().top - _pri.$wrp_lst.offset().top)});
        }
    };

    _pri.onSlotClick = function(e)
    {
        _pri.dbgY('*** onSlotClick() e:', e);

        if (_pri.db_id == '')
        {
            _pri.dbg('    nope ...');
            return;
        }

        _pri.$wrp_lst.find('[data-toggle="tooltip"]').tooltip('dispose');

        let $this = $(this);
        _pri.tss  = $this.data('tss'); // time stamps start/end

        if (!_pri.isObj(_pri.tss))
        {
            return;
        }

        _pri.dbg('    tss:', _pri.tss);

        let cll = {
            _url:   _pri.opts.day_lst_url,
            _dtp:   'JSON',
            _frmdt: $.extend({
                act:     'get_frm',
                fair_id: _pri.conf.fair_id,
                ls_id:   _pri.conf.ls_id,
                fe_ds:   _pri.day_cur
            }, _pri.tss)
        };

        _pri.modal.cll(cll, _pri.onSetSlot);
    };

    _pri.onSetSlot = function(xhr)
    {
        _pri.dbgG('*** onSetSlot() xhr:', xhr);

        var ret = JSON.parse(xhr.responseText);
        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

        _pri.modal.setMask(0, 0, 0);

        _pri.showFrm();
    };

    _pri.onSubSent = function(xhr)
    {
        _pri.dbgG('*** onSetSlot() xhr:', xhr);

        var ret = JSON.parse(xhr.responseText);
        _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
        _pri.modal.handleJSONRet(ret, xhr.statusText, xhr);

        _pri.modal.setMask(0, 0, 0);
    };

    _pri.onChangeDate = function(e)
    {
        // `e` here contains the extra attributes
        _pri.dbgY('*** onChangeDate() e:', e);

        _pri.dbg('    (getDate)', _pri.$cal.datepicker('getFormattedDate'));
        _pri.setDay(_pri.$cal.datepicker('getFormattedDate'));
    };

    _pri.showFrm = function()
    {
        _pri.$wrp_db.addClass('d-none');
        _pri.$wrp_frm.css('opacity', 0);
        _pri.$wrp_frm.removeClass('d-none');
        _pri.$wrp_frm.animate({opacity: '1.0'}, 1000);
        let $inp_email = _pri.$wrp_frm.find('#email');
        if ($inp_email.length > 0)
        {
            $inp_email.focus();
        }
    };

    _pri.onDbFrmSubClick = function()
    {
        _pri.dbgG('*** onDbFrmSub()');

        if (_pri.db_id == '')
        {
            _pri.dbg('    nope ...');
            return;
        }

        let frmdt = {
            act:        'sub_frm',
            fair_id:    _pri.conf.fair_id,
            ls_id:      _pri.conf.ls_id,
            fe_ds:      _pri.day_cur,
            email:      $('#email').val(),
            email2:     $('#email2').val(),
            captcha:    $('#captcha').val()
        };

        let cll = {
            _url:   _pri.opts.day_lst_url,
            _dtp:   'JSON',
            _frmdt: $.extend(frmdt, _pri.tss)
        };

        _pri.modal.cll(cll, _pri.onSubSent);
    };

    _pri.onBckClick = function(e)
    {
        if (_pri.db_id == '')
        {
            _pri.dbg('    nope ...');
            return;
        }

        _pri.showDB();

        let day_cur  = _pri.day_cur;
        _pri.day_cur = '';
        _pri.setDay(day_cur);
    };

    _pri.showDB = function()
    {
        $('#db_msgs').html('');
        _pri.$wrp_frm.addClass('d-none');
        _pri.$wrp_db.css('opacity', 0);
        _pri.$wrp_db.removeClass('d-none');
        _pri.$wrp_db.animate({opacity: '1.0'}, 1000);
    };

    _pri.updOpts = function()
    {
        _pri.dbgG('*** updOpts()', _pri.conf);

        _pri.opts_def = $.extend({}, _pri.opts);

        _pri.opts.dp_opts.startDate          = _pri.conf.day_start;
        _pri.opts.dp_opts.endDate            = _pri.conf.day_end;
        _pri.opts.dp_opts.daysOfWeekDisabled = _pri.conf.days_dis;
    };

    _pri.validDay = function(day)
    {
        return (typeof day === 'string' && _pri.opts.rx_fe_ds.test(day));
    };

    _pri.onCloseDb = function()
    {
        _pri.db_id = '';

        let ret = {
            msk: [0, 0, 0, -1],
            mdlc: true
        };
        _pri.modal.handleJSONRet(ret);
    };

    // _pri.extend();
    _pri.init0();
    // expose public methods
    return publ;
})(jQuery);